<template>
  <section class="flex level-1" v-touch:swipe.right="swipeRightHandler">    
        <!-- //TITLE MOBILE -->
          <div class="mobile"  :class="{isMobile:isMobile}">

            <div class="link">
              <button class="bt btn-back" @click="goBack()">
                <font-awesome-icon :icon="['far', 'angle-left']"/>
              </button>
              <h2>Messagerie</h2>
            </div>
            <div class="sep"></div>
          </div>
        <!-- //TITLE MOBILE -->


        <!-- CONTENT -->

        <div class="block__messagerie content__messagerie">
          <!-- PART MIDDLE -->
          <div class="column-middle">

            <!-- //TITLE DESKTOP -->
              <div class="desktop">
                <h1>Messagerie</h1>
              </div>
            <!-- //TITLE DESKTOP -->       
            
            <Stack></Stack>

            <h2>Composer votre email</h2>

            <Stack></Stack>
            
            <b-card>
              <header>
                <div class="flex">
                  <h2>Destinataire</h2>
                  <router-link class="btn-add" :to="{ name: 'challenges-messgerie-contact'}" v-if="isMobile">Ajouter</router-link>
                </div>
      
                <Stack></Stack>

                <div class="flex selected">
                  <h3>Aucun destinataire sélectionné</h3>
                </div>
              </header>

                <Stack></Stack>


              <div>
                  <b-form-group
                    id="input-group-messagerie-title"
                    label="Objet"
                    label-for="messagerie-title"
                  >
                    <b-form-input
                      id="messagerie-title"
                      required
                      placeholder="Exemple de titre"
                    ></b-form-input>
                  </b-form-group>   


                  <div v-if="isMobile">
                    <b-form-group
                      id="input-group-messagerie-message"
                      label="Votre message"
                      label-for="messagerie-title"
                    >
                      <b-form-textarea
                        id="messagerie-message"
                        rows="8"
                        required
                        placeholder="Votre message"
                      ></b-form-textarea>
                    </b-form-group> 
                  </div>   


                  <Editor
                    apiKey="ft66pqql8qct8gk5w9wvhdxzi1x22n5y61r9nqntppyec9uk"
                    :init="{
                      height: 500,
                      menubar: false,
                      plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                      ],
                      toolbar:
                        'undo redo | formatselect | bold italic backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help'
                    }"
                    v-if="!isMobile"
                  />
                  <Stack height="1rem" class="desktop"></Stack>


                  <div class="buttons-container">
                    <button class="btn btn-send">Envoyer</button>
                    <Stack height="1rem" class="mobile"></Stack>
                    <button class="btn btn-show">Aperçu</button>
                    <Stack height="1rem" class="mobile"></Stack>
                    <button class="btn btn-grey">Annuler</button>
                  </div>

              </div>


            </b-card>
          </div>
          <!-- PART MIDDLE -->

          <!-- PART RIGHT -->
          <div class="col-right column-right borderLeft" v-if="!isMobile">
            <ChallengesMessagerieContact
              noTitle="false"
            ></ChallengesMessagerieContact>
          </div>
          <!-- PART RIGHT -->

        </div>
    <!-- CONTENT-->



    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->
    <transition name="modal"> 
      <keep-alive>
        <router-view name="helper" class="myModal"></router-view>
      </keep-alive>
    </transition>    
    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->


  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import utils from '../../../Utils'
import Stack from '../../../module/stack/Stack'
import ChallengesMessagerieContact from '../../../pages/sub_category/challenges/ChallengesMessagerieContact'
import Editor from '@tinymce/tinymce-vue'


export default {
  name:"challengeMessagerie",
    components:{ 
      Stack,
      ChallengesMessagerieContact,
      Editor
    }, 
    computed: {
      ...mapGetters([
        'getBlog',
        'getLists',
        'getGeneral',
      ])
    },
    data () {
      return {
        content:"",
        general:"",
        lists:"",
        title:"",
        isLoading:true,
        isMobile:false,      
      }
    },
    created (){
      this.content = this.getBlog;
      this.lists = this.getLists;
      this.general = this.getGeneral;
      this.isMobile = utils.isMobile();
      setTimeout(() => {
        this.isLoading = false;
      },2000);      
    },    
    methods : {
      goBack() {
        this.$store.dispatch('goBack')
        this.$router.push({name: "challengesHome"});  
      },    
      swipeRightHandler () {
          this.goBack();
      },          
    },
    mounted(){
      console.log('MOUNTED');
    }
};
</script>
